import { isNullOrWhitespace } from "@common/Common";

export class ProjectUsersTagsManagerViewModel
{
    opened: boolean = false;
    createError: string | null = null;
    updateError: string | null = null;
    tags: TagVM[] = [];
    newTag: string | null = null;

    removeTag(tag: string)
    {
        this.tags = this.tags.filter(t => t.tag !== tag);
    }

    addTag(tag: string)
    {
        this.newTag = null;
        this.tags.push(new TagVM(tag));
    }

    confirmTagUpdate(tag: string)
    {
        this.tags.find(a => a.tag === tag)?.confirmUpdate();
    }


    showCreateError(error: string)
    {
        this.createError = error;
    }

    showUpdateError(error: string)
    {
        this.updateError = error;
    }


    show(tags: string[])
    {
        this.createError = null;
        this.updateError = null;
        this.tags = tags.map(a => new TagVM(a));

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.tags = [];
        this.createError = null;
        this.updateError = null;
    }
}

export class TagVM
{
    tag: string = null;
    renamedTag: string = null;
    editing: boolean = false;

    get canSave(): boolean
    {
        return this.editing === true && !isNullOrWhitespace(this.renamedTag) && this.renamedTag !== this.tag;
    }

    constructor(tag: string)
    {
        this.tag = tag;
    }

    edit()
    {
        this.renamedTag = this.tag;
        this.editing = true;
    }

    cancelEdit()
    {
        this.renamedTag = null;
        this.editing = false;
    }

    confirmUpdate()
    {
        this.tag = this.renamedTag;
        this.editing = false;
    }
}